export const progressionNumbers = [1, 2, 3, 4];
export const romanLevel = number => ['', 'I', 'II', 'III', 'IV'][number] || '';
export const milestoneForLevel = number => number === 1 ? 'once' : romanLevel(number);
export const levelForMilestone = milestone => ({once: 1, II: 2, III: 3, IV: 4})[milestone] || 1;

/** A level is part of its parent patch, never another patch identity. */
export function patchAtLevel(patch, number = 1) {
  const stage = patch.progression_levels?.find(level => level.number === number);
  return stage ? {...patch, ...stage, name: `${patch.name} ${romanLevel(number)}`,
    level: stage.rarity, progression_level: number, points: number === 1 ? patch.points : 0}
    : {...patch, progression_level: patch.progression_levels ? number : null};
}

/** Raw award history remains complete; collections select only active holdings. */
export function highestPatchAwards(awards) {
  const patches = new Map();
  for (const award of awards) {
    if (award.revoked_at) continue;
    const previous = patches.get(award.badge_id);
    if (!previous || (award.progression_level || 1) > (previous.progression_level || 1))
      patches.set(award.badge_id, award);
  }
  return [...patches.values()];
}

export function projectPatchAward(award, definition, snapshot) {
  const number = levelForMilestone(award.milestone);
  const current = patchAtLevel(definition, number), earned = patchAtLevel(snapshot, number);
  return {...award, name: earned.name, description: earned.description, image: earned.image,
    story: earned.story, presentation_kind: earned.presentation_kind,
    display_name: current.name, display_image: current.image || earned.image,
    level: current.level, progression_level: definition.progression_levels ? number : null};
}

/** Keep each patch's reveals in level order without discarding any award. */
export function orderPatchReveals(awards) {
  const groups = new Map();
  for (const award of awards) {
    if (!groups.has(award.badge_id)) groups.set(award.badge_id, []);
    groups.get(award.badge_id).push(award);
  }
  return [...groups.values()].flatMap(group => group.sort((a, b) =>
    (a.progression_level || 1) - (b.progression_level || 1)));
}
